import React, { FC } from 'react';
import Helmet from 'react-helmet';

type Props = {
  breadcrumbs: Array<{ url: string; label: string; current?: boolean }>;
};

export const BreadcrumbJsonLd: FC<Props> = ({ breadcrumbs }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbs.map((value, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: value.label,
            ...(value.current
              ? {}
              : {
                  // if index === 0 so the url should not have trailing slash -> doctrine.fr/
                  item: `https://www.doctrine.fr${
                    index === 0 ? '' : value.url
                  }`,
                }),
          })),
        })}
      </script>
    </Helmet>
  );
};
